import React from 'react';
import styles from './multiplePresetIndication.scss';

const MultiplePresetIndication: React.FC = () => (
  <div className={styles.multiplePresetIndication} />
);

export default MultiplePresetIndication;
